"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GridOperator;
(function (GridOperator) {
    GridOperator["002LIANDER"] = "002Liander";
    GridOperator["STEDIN"] = "stedin";
    GridOperator["GDS"] = "gds";
    GridOperator["ENX"] = "enx";
    GridOperator["WESTLAND"] = "Westland";
    GridOperator["STEDINDNWG"] = "stedinDNWG";
    GridOperator["COTEQ"] = "coteq";
    GridOperator["RENDO"] = "rendo";
    GridOperator["MULTIPLE"] = "multiple";
})(GridOperator || (GridOperator = {}));
exports.default = GridOperator;
